<template>
  <div class="d-block text-justify">
    <div v-if="customer == 'simonetti'" class="my-3">
      <h3>PAGO MODALIDAD CARGO AUTOMÁTICO - TRANSBANK</h3>
      <b>Introducción.</b><br />
      Las personas que suscriban contratos de promesa de compraventa (Cliente)
      por uno o más inmuebles con Simonetti (Simonetti Inmobiliaria S.A.,
      Simonetti Constructora SpA), podrán acceder a la modalidad de pago de
      parte o todo el precio de sus respectivos contratos, mediante el cargo
      automático que se haga en sus respectivas cuentas corrientes bancarias o
      tarjetas de crédito, utilizando la plataforma que para tales efectos
      mantenga vigente Transbank, quien en calidad de mandatario y mero tenedor,
      facilitará el proceso de pago correspondiente, a través de cuotas
      convenidas en los contratos de promesa de compraventa o compraventa
      respectivos. A tales efectos el Cliente otorgará un mandato específico a
      Transbank y/o cualquier otro documento que sea necesario y/o requerido por
      este último, y deberá aceptar los términos y condiciones contenidos que se
      indica a continuación.<br />
      <b>Mecanismo:</b><br />
      Para acceder esta forma de pago, el Cliente deberá ingresar a Mi Cuenta en
      la página web de Simonetti (www. Simonetti.cl), y elegir dentro de las
      opciones para materializar el pago de su respectivo contrato y de acuerdo
      a lo convenido en él, el número de cuotas, el monto de ellas y la fecha de
      pago/cargo. Para tales efectos, deberá seleccionar la opción “Pagos”,
      accediendo a la interfaz de ésta, mediante la cual, dependiendo de la
      opción que escoja, podrá a su vez optar por el pago mediante PAC (pago
      automático en cuenta corriente) o PAT (pago automático en tarjeta de
      crédito), canalizándose a través de Webpay Oneclick de Transbank y/o
      mediante otra u otras que podrían estar disponibles para los mismos
      efectos, caso en el cual se conectará a ellas, aplicando asimismo los
      términos y condiciones particulares de la correspondiente Webpay.<br />
      Cualquiera sea la opción de pago que escoja el Cliente mediante la
      plataforma Mi Cuenta - Pagos, deberá ingresar, completar, otorgar y/o
      suscribir todos los antecedentes, mandatos y/o demás información que al
      efecto se requiera.<br />
      Cualquiera que sea la modalidad elegida por el Cliente, deberá respetar la
      periodicidad, número de cuotas, monto y fecha de pago/cargo que se
      convenga en el respectivo contrato de promesa de compraventa o de
      compraventa que Simonetti y el Cliente suscriban.<br />
      Cualquier transacción que se efectúe mediante el sistema referido, será
      canalizada y administrada a través de los sistemas y páginas web que
      Transbank disponga para ello. La web de Simonetti, solo permitirá
      redireccionar a cada Cliente a los referidos sistemas y páginas web, por
      lo que Simonetti no tendrá acceso ni guardará los datos ingresados por el
      Cliente, cualquiera que estos sean y especialmente respecto de la cuenta
      y/o tarjeta registradas por el Cliente al configurar la opción de pago.
      Simonetti no tendrá responsabilidad alguna ni podrá imputársele cualquier
      problema de permeabilidad y/o fallas que puedan experimentar los sistemas
      y/o las páginas web de Transbank, mediante la cual se materialice el pago,
      y/o que en virtud de ello, pueda experimentar la cuenta y/o tarjeta
      registradas.<br />
      El Cliente solo podrá tener activa 1(una) cuenta o tarjeta por cada
      contrato que suscriba con Simonetti, por lo que si el Cliente deseara
      reemplazar la cuenta o tarjeta que hubiere registrado y reemplazarla por
      otra que estuviere vigente, podrá hacerlo directamente a través de la web
      de Simonetti. Cualquier cambio que se realice respecto de la modalidad de
      pago deberá acordarse previamente entre Simonetti y el Cliente y darse
      cuenta de ello mediante la ceebración de la respectiva modificación del
      contrato de promesa de compraventa que se hubiere firmado.<br />
      <h4 class="my-4">
        AUTORIZACIÓN PAGO AUTOMÁTICO EN CUENTA CORRIENTE O EN TARJETA DE CREDITO
      </h4>
      Con la aceptación de los presentes términos y condiciones, independiente
      de los mandatos que al afecto deban otorgarse, y/o de los términos y
      condiciones propios de Transbank disponga al efecto, el Cliente autoriza
      por esta aceptación, expresamente a Transbank para que ésta concurra al
      Banco que corresponda, y le solicite los fondos que corresponda, con cargo
      a la Cuenta Corriente y/o a la Tarjeta de Crédito designada para tal
      efecto, y que con dichos fondos proceda directamente al pago de las cuotas
      que he comprometido pagar a Simonetti, destinando al pago al pago del
      precio del contrato de promesa de compraventa respectivo, calculado en
      base al valor de la UF del día de pago acordado y/o efectivo.<br />
      El pago, para el caso de Pago Automático con cargo a la Cuenta Corriente,
      ser materializará mediante la transferencia directa a la Simonetti. La
      presente autorización tiene vigencia indefinida.<br />

      El Cliente podrá revocar esta autorización, siempre que en forma previa
      haya acordado con Simonetti la nueva modalidad de pago, de lo que deberá
      darse cuenta de ello mediante la celebración de la respectiva modificación
      del contrato de promesa de compraventa que se hubiere firmado. La presente
      autorización se entenderá otorgada, para todos los efectos legales, el
      mismo día en que, a través de la web de Simonetti, se proceda a configurar
      la opción de pago a través de la opción Transbank, entregándose,
      otorgándose y/o suscribiéndose todos los antecedentes, mandatos y/o demás
      información que al efecto ésta requiera.<br />
      Todas las autorizaciones que se hubieren otorgado en forma indefinida, se
      entenderán renovadas mes a mes, en tanto no se revoque por escrito.
    </div>
    <div v-else-if="customer == 'gespania'" class="my-3">
      <h3>PAGO MODALIDAD CARGO AUTOMÁTICO - TRANSBANK</h3>
      <b>Introducción.</b><br />
      Las personas que suscriban contratos de promesa de compraventa (Cliente)
      por uno o más inmuebles con el Grupo Gespania (Inmobiliaria El Rosal S.A.,
      Inmobiliaria Las Palmeras S.A., Inmobiliaria Altos del Mar SPA,
      Inmobiliaria Andalucía S.A., Inmobiliaria Lazo S.A., Inmobiliaria Salas
      S.A., Inmobiliaria La Fontana S.A.), podrán acceder a la modalidad de pago
      de parte o todo el precio de sus respectivos contratos, mediante el cargo
      automático que se haga en sus respectivas cuentas corrientes bancarias o
      tarjetas de crédito, utilizando la plataforma que para tales efectos
      mantenga vigente Transbank, quien en calidad de mandatario y mero tenedor,
      facilitará el proceso de pago correspondiente, a través de cuotas
      convenidas en los contratos de promesa de compraventa o compraventa
      respectivos. A tales efectos el Cliente otorgará un mandato específico a
      Transbank y/o cualquier otro documento que sea necesario y/o requerido por
      este último, y deberá aceptar los términos y condiciones contenidos que se
      indica a continuación.
      <br /><b>Mecanismo:</b><br />
      Para acceder a esta forma de pago, el Cliente deberá ingresar a la página
      web de Gespania (www.gespania.cl), y elegir dentro de las opciones para
      materializar el pago de su respectivo contrato y de acuerdo a lo convenido
      en él, el número de cuotas, el monto de ellas y la fecha de pago/cargo.
      Para tales efectos, deberá seleccionar la opción "Pagos", accediendo a la
      interfaz de ésta, mediante la cual, dependiendo de la opción que escoja,
      podrá a su vez optar por el pago mediante PAC (pago automático en cuenta
      corriente) o PAT (pago automático en tarjeta de crédito), canalizándose a
      través de Webpay Oneclick de Transbank y/o mediante otra u otras que
      podrían estar disponibles para los mismos efectos, caso en el cual se
      conectará a ellas, aplicando asimismo los términos y condiciones
      particulares de la correspondiente Webpay. Cualquiera sea la opción de
      pago que escoja el Cliente mediante la plataforma, deberá ingresar,
      completar, otorgar y/o suscribir todos los antecedentes, mandatos y/o
      demás información que al efecto se requiera. Cualquiera que sea la
      modalidad elegida por el Cliente, deberá respetar la periodicidad, número
      de cuotas, monto y fecha de pago/cargo que se convenga en el respectivo
      contrato de promesa de compraventa o de compraventa que Gespania y el
      Cliente suscriban. Cualquier transacción que se efectúe mediante el
      sistema referido, será canalizada y administrada a través de los sistemas
      y páginas web que Transbank disponga para ello. La web de Gespania, solo
      permitirá redireccionar a cada Cliente a los referidos sistemas y páginas
      web, por lo que Gespania no tendrá acceso ni guardará los datos ingresados
      por el Cliente, cualquiera que estos sean y especialmente respecto de la
      cuenta y/o tarjeta registradas por el Cliente al configurar la opción de
      pago. Gespania no tendrá responsabilidad alguna ni podrá imputársele
      cualquier problema de permeabilidad y/o fallas que puedan experimentar los
      sistemas y/o las páginas web de Transbank, mediante la cual se materialice
      el pago, y/o que en virtud de ello, pueda experimentar la cuenta y/o
      tarjeta registradas. El Cliente solo podrá tener activa 1(una) cuenta o
      tarjeta por cada contrato que suscriba con Gespania, por lo que si el
      Cliente deseara reemplazar la cuenta o tarjeta que hubiere registrado y
      reemplazarla por otra que estuviere vigente, podrá hacerlo directamente a
      través de la web de Gespania. Cualquier cambio que se realice respecto de
      la modalidad de pago deberá acordarse previamente entre Gespania y el
      Cliente y darse cuenta de ello mediante la celebración de la respectiva
      modificación del contrato de promesa de compraventa que se hubiere
      firmado.
      <br />
      <h4 class="my-4">
        AUTORIZACIÓN PAGO AUTOMÁTICO EN CUENTA CORRIENTE O EN TARJETA DE CREDITO
      </h4>
      <br />
      Con la aceptación de los presentes términos y condiciones, independiente
      de los mandatos que al afecto deban otorgarse, y/o de los términos y
      condiciones propios de Transbank disponga al efecto, el Cliente autoriza
      por esta aceptación, expresamente a Transbank para que ésta concurra al
      Banco que corresponda, y le solicite los fondos que corresponda, con cargo
      a la Cuenta Corriente y/o a la Tarjeta de Crédito designada para tal
      efecto, y que con dichos fondos proceda directamente al pago de las cuotas
      que he comprometido pagar a Gespania, destinando al pago del precio del
      contrato de promesa de compraventa respectivo, calculado en base al valor
      de la UF del día de pago acordado y/o efectivo.
      <br />
      El pago, para el caso de Pago Automático con cargo a la Cuenta Corriente,
      se materializará mediante la transferencia directa a la de Gespania. La
      presente autorización tiene vigencia indefinida.
      <br />
      El Cliente podrá revocar esta autorización, siempre que en forma previa
      haya acordado con Gespania la nueva modalidad de pago, de lo que deberá
      darse cuenta de ello mediante la celebración de la respectiva modificación
      del contrato de promesa de compraventa que se hubiere firmado. La presente
      autorización se entenderá otorgada, para todos los efectos legales, el
      mismo día en que, a través de la web de Gespania, se proceda a configurar
      la opción de pago a través de la opción Transbank, entregándose,
      otorgándose y/o suscribiéndose todos los antecedentes, mandatos y/o demás
      información que al efecto ésta requiera. Todas las autorizaciones que se
      hubieren otorgado en forma indefinida, se entenderán renovadas mes a mes,
      en tanto no se revoque por escrito.
    </div>
    <div v-else>
      <h3>INTRODUCCIÓN</h3>
      PAGO MODALIDAD CARGO AUTOMÁTICO - TRANSBANK Introducción. Las personas que
      suscriban contratos de promesa de compraventa (Cliente) por uno o más
      inmuebles con La Inmobiliaria (La Inmobiliaria Inmobiliaria S.A.), podrán
      acceder a la modalidad de pago de parte o todo el precio de sus
      respectivos contratos, mediante el cargo automático que se haga en sus
      respectivas cuentas corrientes bancarias o tarjetas de crédito, utilizando
      la plataforma que para tales efectos mantenga vigente Transbank, quien en
      calidad de mandatario y mero tenedor, facilitará el proceso de pago
      correspondiente, a través de cuotas convenidas en los contratos de promesa
      de compraventa o compraventa respectivos. A tales efectos el Cliente
      otorgará un mandato específico a Transbank y/o cualquier otro documento
      que sea necesario y/o requerido por este último, y deberá aceptar los
      términos y condiciones contenidos que se indica a continuación. Mecanismo:
      Para acceder esta forma de pago, el Cliente deberá ingresar al portal de
      clientes en la página web de La Inmobiliaria, y elegir dentro de las
      opciones para materializar el pago de su respectivo contrato y de acuerdo
      a lo convenido en él, el número de cuotas, el monto de ellas y la fecha de
      pago/cargo. Para tales efectos, deberá seleccionar la opción “Pagos”,
      accediendo a la interfaz de ésta, mediante la cual, dependiendo de la
      opción que escoja, podrá a su vez optar por el pago mediante PAC (pago
      automático en cuenta corriente) o PAT (pago automático en tarjeta de
      crédito), canalizándose a través de Webpay Oneclick de Transbank y/o
      mediante otra u otras que podrían estar disponibles para los mismos
      efectos, caso en el cual se conectará a ellas, aplicando asimismo los
      términos y condiciones particulares de la correspondiente Webpay.
      Cualquiera sea la opción de pago que escoja el Cliente mediante la
      plataforma Mi Cuenta - Pagos, deberá ingresar, completar, otorgar y/o
      suscribir todos los antecedentes, mandatos y/o demás información que al
      efecto se requiera. Cualquiera que sea la modalidad elegida por el
      Cliente, deberá respetar la periodicidad, número de cuotas, monto y fecha
      de pago/cargo que se convenga en el respectivo contrato de promesa de
      compraventa o de compraventa que La Inmobiliaria y el Cliente suscriban.
      Cualquier transacción que se efectúe mediante el sistema referido, será
      canalizada y administrada a través de los sistemas y páginas web que
      Transbank disponga para ello. La web de La Inmobiliaria, solo permitirá
      redireccionar a cada Cliente a los referidos sistemas y páginas web, por
      lo que La Inmobiliaria no tendrá acceso ni guardará los datos ingresados
      por el Cliente, cualquiera que estos sean y especialmente respecto de la
      cuenta y/o tarjeta registradas por el Cliente al configurar la opción de
      pago. La Inmobiliaria no tendrá responsabilidad alguna ni podrá
      imputársele cualquier problema de permeabilidad y/o fallas que puedan
      experimentar los sistemas y/o las páginas web de Transbank, mediante la
      cual se materialice el pago, y/o que en virtud de ello, pueda experimentar
      la cuenta y/o tarjeta registradas. El Cliente solo podrá tener activa
      1(una) cuenta o tarjeta por cada contrato que suscriba con Bravo
      Izquierdo, por lo que si el Cliente deseara reemplazar la cuenta o tarjeta
      que hubiere registrado y reemplazarla por otra que estuviere vigente,
      podrá hacerlo directamente a través de la web de La Inmobiliaria.
      Cualquier cambio que se realice respecto de la modalidad de pago deberá
      acordarse previamente entre La Inmobiliaria y el Cliente y darse cuenta de
      ello mediante la ceebración de la respectiva modificación del contrato de
      promesa de compraventa que se hubiere firmado. AUTORIZACIÓN PAGO
      AUTOMÁTICO EN CUENTA CORRIENTE O EN TARJETA DE CREDITO Con la aceptación
      de los presentes términos y condiciones, independiente de los mandatos que
      al afecto deban otorgarse, y/o de los términos y condiciones propios de
      Transbank disponga al efecto, el Cliente autoriza por esta aceptación,
      expresamente a Transbank para que ésta concurra al Banco que corresponda,
      y le solicite los fondos que corresponda, con cargo a la Cuenta Corriente
      y/o a la Tarjeta de Crédito designada para tal efecto, y que con dichos
      fondos proceda directamente al pago de las cuotas que he comprometido
      pagar a La Inmobiliaria, destinando al pago al pago del precio del
      contrato de promesa de compraventa respectivo, calculado en base al valor
      de la UF del día de pago acordado y/o efectivo. El pago, para el caso de
      Pago Automático con cargo a la Cuenta Corriente, ser materializará
      mediante la transferencia directa a la La Inmobiliaria. La presente
      autorización tiene vigencia indefinida. El Cliente podrá revocar esta
      autorización, siempre que en forma previa haya acordado con Bravo
      Izquierdo la nueva modalidad de pago, de lo que deberá darse cuenta de
      ello mediante la celebración de la respectiva modificación del contrato de
      promesa de compraventa que se hubiere firmado. La presente autorización se
      entenderá otorgada, para todos los efectos legales, el mismo día en que, a
      través de la web de La Inmobiliaria, se proceda a configurar la opción de
      pago a través de la opción Transbank, entregándose, otorgándose y/o
      suscribiéndose todos los antecedentes, mandatos y/o demás información que
      al efecto ésta requiera. Todas las autorizaciones que se hubieren otorgado
      en forma indefinida, se entenderán renovadas mes a mes, en tanto no se
      revoque por escrito.
    </div>
  </div>
</template>
<script>
export default {
  name: "payments",
  components: {},
  props: {
    legal_name: null,
    project_id: { default: null },
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
  },
};
</script>
